import { DRect } from "src/app/binst/primitives/drawable-rect";
import {PixiObject} from "../primitives/pixi-object";
import {Rect, RectConstructor} from "../../../primitives/rect";
import {ColorSource, Graphics} from "pixi.js";


export class BackgroundDrawable extends PixiObject {
    graphics: Graphics;

    constructor(config: {
        id?: string
        width: number;
        height: number;
        roundness?: number;
        color?: ColorSource;
        zDepth?: number;
    }) {
        super(config);
        this.drawBackground(config.width, config.height, config.zDepth ?? 0);
        this.updateTouchBounds()
    }

    drawBackground(width, height, zDepth) {
        if (this.graphics) {
            this.graphics.destroy();
        }
        this.graphics = new Graphics({});
        const rect = new DRect({
            left: 0,
            top: 0,
            right: width,
            bottom: height,
            roundness: this.config?.roundness || 10,
            colour: this.config?.color || '#252525', //this.generateNeonColor(10),// "#252525",//this.niceColourMaker(),
            strokeColor: "1D1D1D",//, this.generateNeonColor(50),
            strokeWidth: 10,
        });
        rect.render(this.graphics);
        this.graphics.zIndex = zDepth || 0;
        this.sprite.addChild(this.graphics);
    }

    override setRect(config: RectConstructor & {zDepth?: number}) {
        const r = new Rect(config)
        // this.sprite.x =  r.x;
        // this.sprite.y = r.y;
        // this.sprite.width = r.width;
        // this.sprite.height = r.height;
        this.drawBackground(r.width, r.height, config.zDepth ?? 0);
        this.updateTouchBounds()
    }


    generateNeonColor(lightness) {
        // 1. Pick a completely random hue (0 to 360 degrees)
        const hue = Math.floor(Math.random() * 180) + 180;

        // 2. Lock Saturation to 100% for maximum purity/vibrancy
        const saturation = 100;

        // 3. Keep Lightness around 50-55% so it's bright but not washed out (white)
        // const lightness = Math.floor(Math.random() * 10) + 50;

        return this.hslToHex(hue, saturation, lightness);
    }

    /**
     * Helper function to convert HSL to Hex format
     */
    hslToHex(h, s, l) {
        l /= 100;
        const a = (s * Math.min(l, 1 - l)) / 100;
        const f = n => {
            const k = (n + h / 30) % 12;
            const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
            return Math.round(255 * color).toString(16).padStart(2, '0');
        };
        return `#${f(0)}${f(8)}${f(4)}`.toUpperCase();
    }


      niceColourMaker() {
        const r = 0.2 + (Math.random() * 0.05 - 0.02);
        const g = 0.2 + (Math.random() * 0.05 - 0.02);
        const b = 0.2 + (Math.random() * 0.05 - 0.02);
        return [r, g, b, 1];
      }

    override setupDefaultInteractions() {
        // this.touchContainer.onPressed((pt) => {
        //     this.sprite.alpha = 0.5;
        //     this.requestRender()
        //     return false; // Stop propagation
        // });
        // this.touchContainer.onReleased((pt) => {
        //     this.sprite.alpha = 1;
        //     this.requestRender()
        //     return false; // Stop propagation
        // });

    }

}
